import Swal from "sweetalert2";
import api from "@/services/api";
import router from "@/router";
import { appService } from "@/services/app.service";

interface CheckCampaignOptions {
  culture: string;
  onConfirm?: () => void;
  onClose?: () => void;
}

export const CampaignService = {
  checkAndShowOffer(options: CheckCampaignOptions) {
    const { culture, onConfirm, onClose } = options;
    const _appService = appService();

    return api()
      .get("/Campaign/CheckUserCampaign")
      .then((checkResponse) => {
        if (checkResponse.data && checkResponse.data.canBenefit === true) {
          Swal.fire({
            title: _appService.t("Ozel Firsatlar popup baslik", "Özel Fırsat"),
            text: _appService.t(
              "Ozel Firsatlar popup metin",
              "Yeni dönem fiyatlarımıza geçmeden size özel fırsatlarımızdan yararlanmak ister misiniz?"
            ),
            icon: "info",
            iconColor: "#ef7850",
            iconHtml: `<?xml version="1.0" encoding="UTF-8"?><svg id="b" width="90" height="90" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 857.81 857.81"><path d="M428.91,0C192.03,0,0,192.03,0,428.91s192.03,428.91,428.91,428.91,428.91-192.03,428.91-428.91S665.79,0,428.91,0h0Z" style="fill:#e95b0c;"/><path d="M166.59,542.27c-21.05-12.32-36.05-32.11-42.22-55.72-6.17-23.6-2.78-48.19,9.55-69.24,12.33-21.05,32.11-36.05,55.71-42.22l5.12-1.34,46.21,176.72-5.12,1.34c-23.6,6.17-48.19,2.78-69.25-9.54ZM407.46,698.41c-1.94,3.77-5.27,6.44-9.37,7.51l-29.23,7.64c-6.36,1.66-13.12,1-19.03-1.86-5.92-2.86-10.63-7.75-13.28-13.76l-55.25-125.49,75.56-19.76,51.25,133.71c1.52,3.96,1.29,8.22-.65,11.99ZM363.93,540.23l-93.53,24.45c-7.8,2.04-15.8-2.65-17.84-10.45l-.36-1.39s0,0,0,0,0,0,0,0l-48.8-186.64s0,0,0,0,0,0,0,0l-.36-1.39c-2.04-7.8,2.65-15.8,10.45-17.84l93.53-24.45c7.8-2.04,15.8,2.65,17.84,10.45l49.53,189.44c2.04,7.8-2.65,15.8-10.45,17.84ZM621.82,543.07c-24.62-14.36-54.11-24.46-87.64-30.03-44.71-7.43-95.44-6.43-150.86,2.96l-47.55-181.84c41.56-14.88,78.27-32.95,109.15-53.75,25.73-17.33,47.52-36.59,64.76-57.25,16.09-19.28,25.24-36.23,30.29-47.91l99.19,379.36c-4.55-3.47-10.29-7.42-17.34-11.53ZM684.73,560.14c2.26,8.65-2.93,17.52-11.58,19.78s-17.52-2.93-19.78-11.58l-107.73-412.01h0c-2.26-8.65,2.93-17.52,11.58-19.78s17.52,2.93,19.78,11.58l107.73,412.01ZM679.06,355.97c.11,2.09-.86,4.06-2.59,5.27l-28,19.61-15.33-58.64,34.02,3.4c2.1.21,3.91,1.45,4.83,3.32,1.5,3.04,3.59,7.79,4.99,13.14,1.4,5.36,1.9,10.52,2.08,13.9Z" style="fill:#fff;"/></svg>`,
            showCancelButton: true,
            confirmButtonText: _appService.t(
              "Ozel Firsatlar popup kabul butonu",
              "Fırsatları göster"
            ),
            cancelButtonText: _appService.t(
              "Ozel Firsatlar popup kapat butonu",
              "Kapat"
            ),
            confirmButtonColor: "#ef7850",
            cancelButtonColor: "#754c86",
          }).then((result) => {
            if (result.isConfirmed) {
              if (onConfirm) {
                onConfirm();
              } else {
                router.push({
                  name: "SpecialOffers",
                  params: { culture },
                });
              }
            } else {
              if (onClose) onClose();
            }
          });
        } else {
          if (onClose) onClose();
        }
      })
      .catch((error) => {
        console.error("Kampanya kontrolü hatası:", error);
        if (onClose) onClose();
      });
  },
};
